import React, { Component } from 'react'
import { Row, Col, Tag, Button, Input, Carousel, Card } from 'antd'
import { app, config } from "../../app"
import '../../css/expert.css'
import moment from "moment";

class EMDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imgBox: [],
            reason: '',
            flag_title: '',
            family_info2: null,
            showBohui: false,
        }
    }

    componentDidMount() {
        this._isMounted = true
        console.log(this.props);
        // console.log(JSON.stringify(this.props.info.family_info));
        // 处理寻人状态
        if (this.props.flagArr != '') {
            this.props.flagArr.forEach(e => {
                if (e.id === this.props.info.flag) {
                    this.setData({
                        flag_title: e.title
                    })
                }
            });
        }
        // 处理联系人
        if (this.props.info.family_info) {
            this.setData({
                family_info2: this.props.info.family_info !== null ? this.props.info.family_info : null
            })
        }
        if (this.props.info.img_path) {
            this.setState({
                imgBox: this.props.info.img_path !== '' ? this.props.info.img_path.split(":::") : []
            })
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data);

    // 通过审核or驳回
    auditOperation(id = this.props.info.auditId, type = 1, reason = '') {
        // type 1 通过 2 不通过
        this.props.audit(id, type, reason);
    }

    // 弹出驳回输入框
    onCancle() {
        this.setData({
            showBohui: true,
        })
        this.toBohui();
    }

    // 提交驳回信息
    toBohui() {
        const { reason } = this.state;
        if (reason === '') {
            app.alert("请填写驳回原因", "warn");
            return;
        }
        this.auditOperation(this.props.info.auditId, 2, reason);
    }

    // 监听驳回信息
    monitorInpValue(e) {
        // console.log(e.target.value)
        this.setData({
            reason: e.target.value
        })
    }

    // 计算年龄（仅计算年龄以及月龄）
    getAge(e) {
        let nowYear = new Date().getFullYear();
        let targetYear = Number(moment(e).format("YYYY"));
        // console.log(nowYear, targetYear);
        // return '8岁'
        // 如果是同一年，则判断月份
        if (nowYear === targetYear) {
            let nowMonth = new Date().getMonth() + 1;
            // 注意：getMonth返回值是0(1月)~11(12月)之间的一个整数，月份从0开始，11结束，0就是1月
            // moment().format("MM")也是如此
            let targetMonth = Number(moment(e).format("MM"));
            // console.log(nowMonth, targetMonth, e);
            // 如果月份相同，则判断天数
            if (nowMonth === targetMonth) {
                return '未满月';
            } else {
                return nowMonth - targetMonth + '月';
            }
        } else {
            return nowYear - targetYear + '岁';
        }
    }

    render() {
        const { info } = this.props;
        const { imgBox, reason, family_info2, flag_title, showBohui } = this.state;
        return (
            <div>
                <Row gutter={12} style={{ marginBottom: 100 }}>
                    <Col span={12}>
                        <Col span={24}>
                            <Card title="基本信息" size='small'>
                                <div style={styles.flexBox}>
                                    <div style={styles.imgBox}>
                                        <img style={{ ...styles.img, borderRadius: '4px' }}
                                            src={config.imgUrl + app.urlEncode(imgBox[0] || '-')} alt="头像" />
                                    </div>
                                    <div style={styles.userInfo}>
                                        <div style={styles.epcciItem}>
                                            <span>姓名：</span>
                                            <span style={styles.epccicontent}>{info.name || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>性别：</span>
                                            <span style={styles.epccicontent}>{info.sex || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>年龄：</span>
                                            <span style={styles.epccicontent}>{info.date !== '' ? this.getAge(info.date) : '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪时身高：</span>
                                            <span style={styles.epccicontent}>{info.height || '-'}cm</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪日期：</span>
                                            <span style={styles.epccicontent}>{info.date ? moment(info.date).format("YYYY-MM-DD") : '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪地区：</span>
                                            <span style={styles.epccicontent}>{info.province || '-未知省-'}/{info.city || '-未知市-'}/{info.district || '-未知区-'}</span>
                                        </div>

                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={24} style={styles.gutter}>
                            <Card title="失踪详情" size='small'>
                                <div style={styles.flexBox}>
                                    <div style={{ ...styles.userInfo, margin: 0 }}>
                                        <div style={styles.epcciItem}>
                                            <span>失踪地址：</span>
                                            <span style={styles.epccicontent}>{info.address || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪人特征：</span>
                                            <span style={styles.epccicontent}>{info.feature || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪时体重：</span>
                                            <span style={styles.epccicontent}>{info.weight || '-'}kg</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>失踪概况：</span>
                                            <span style={styles.epccicontent}>{info.descript || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col span={24} >
                            <Card title="其他信息" size='small'>
                                <div style={styles.flexBox}>
                                    <div style={{ ...styles.userInfo, margin: 0 }}>
                                        <div style={styles.epcciItem}>
                                            <span>联系方式：</span>
                                            {
                                                family_info2 !== null ?
                                                    (
                                                        family_info2.family_name1 !== null && family_info2.family_name1 !== '' ?
                                                            <span style={styles.epccicontent}>{family_info2.family_name1 || '-'}({family_info2.family_phone1 || '-'})</span>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                            {
                                                family_info2 !== null ?
                                                    (
                                                        family_info2.family_name1 !== null && family_info2.family_name1 !== '' && family_info2.family_name2 !== null && family_info2.family_name2 !== '' ?
                                                            <span>、</span>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                            {
                                                family_info2 !== null ?
                                                    (
                                                        family_info2.family_name2 !== null && family_info2.family_name2 !== '' ?
                                                            <span style={styles.epccicontent}>{family_info2.family_name2 || '-'}({family_info2.family_phone2 || '-'})</span>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>寻找状态：</span>
                                            <span style={styles.epccicontent}>{flag_title || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>寻人类型：</span>
                                            <span style={styles.epccicontent}>{info.type_title || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>审核状态：</span>
                                            <span style={styles.epccicontent}>{info.type_title || '-'}</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>审核不通过理由：</span>
                                            <span style={styles.epccicontent}>{flag_title || '-'}</span>
                                        </div>
                                        {/* <div style={styles.epcciItem}>
                                            <span>找到地址：</span>
                                            <span style={styles.epccicontent}>在广西钦州钦南一座荒无人烟的小山上找到的</span>
                                        </div>
                                        <div style={styles.epcciItem}>
                                            <span>找到日期：</span>
                                            <span style={styles.epccicontent}>2038-03-08</span>
                                        </div> */}
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Col>

                    <Col span={12}>
                        <Col span={24}>
                            <Card title="相关照片" size='small'>
                                <Carousel
                                >
                                    {
                                        imgBox.map((e, i) => {
                                            return (
                                                <div key={i} style={{
                                                    // display: 'flex',
                                                    // alignItems: 'center',
                                                    // width: '509px',
                                                    // height: '540px',
                                                }}>
                                                    <img style={{ maxWidth: '509px', maxHeight: '540px', borderRadius: '4px' }}
                                                        src={config.imgUrl + e} alt="相关照片" />
                                                </div>
                                            )
                                        })
                                    }
                                </Carousel>
                            </Card>

                        </Col>
                        {/* 用户查看详情没有权限操作 */}
                        {
                            this.props.user === 1 ?
                                null
                                :
                                <Col span={24} style={{ marginTop: 24 }}>
                                    <Card title="操作" size='small'>
                                        {
                                            showBohui ?
                                                <div>
                                                    <div style={{ marginBottom: 12 }}>驳回原因（驳回时填写）：</div>
                                                    <Input.TextArea rows={2} value={reason} onChange={(e) => this.monitorInpValue(e)} />
                                                </div>
                                                :
                                                null
                                        }
                                        <div style={{ ...styles.flexBox, marginTop: 24, justifyContent: 'flex-end' }}>
                                            <Button style={{ marginRight: '12px' }} type="danger" onClick={() => this.onCancle()}>驳回</Button>
                                            <Button type='primary' onClick={() => this.auditOperation()}>通过</Button>
                                        </div>
                                    </Card>
                                </Col>
                        }
                    </Col>
                </Row>
            </div>
        )
    }
}

export default EMDetail

const styles = {
    flexBox: {
        display: 'flex',
    },
    gutter: {
        marginTop: '24px',
        marginBottom: '24px'
    },
    imgBox: {
        width: '158px',
        height: '222px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f9f9f9',
        borderRadius: '4px'
    },
    img: {
        maxWidth: '158px',
        maxHeight: '222px',
    },
    marlr: {
        marginLeft: '10px',
        marginRight: '10px'
    },
    userInfo: {
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        marginLeft: '24px'
    },
    otherInfo: {
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        marginLeft: '48px'
    },
    epcciItem: {
        marginBottom: '8px',
        fontWeight: 600
    },
    epccicontent: {
        color: '#999',
        fontWeight: 500
    }

}


// WEBPACK FOOTER //
// ./src/routes/find/FMDetail.jsx